import * as api from "../Api";

export const allActiveAssets = () => async (dispatch) => {
  try {
    const { data } = await api.activeAsset();
    dispatch({ type: "GET_ALL_ACTIVE_ASSETS", payload: data });
  } catch (error) {}
};
